/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function PackageIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "package", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M12.5 3L4.5 8V17L12.5 22L20.5 17V8L12.5 3Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 13V22M12.5 13L4.5 8M12.5 13L20.5 8", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M8.5 5.5L16.5 10.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(PackageIcon);
export default ForwardRef;
//# sourceMappingURL=packageIcon.js.map